import { Component, OnInit, Output, EventEmitter, HostListener, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { TravelersService } from '../../travelers/travelers.service';
import { TravellersService } from '../../travelers/travellers.service';
import { AccessibilityService } from '../../../services/accessibility.service';
import { HttpService } from '../../../services/http.service';
import { LandingComponent } from '../../landing/landing.component';
import { BuywifiService } from '../../../services/buywifi.service';
import { AppService } from '../../../app.service';


@Component({
  selector: 'app-voucher-login',
  templateUrl: './voucher-login.component.html',
  styleUrls: ['./pnr-login.component.css']
})
export class VoucherLoginComponent implements OnInit {
  public displayPNRInfo = false;
  public displayPNRInfoIcon = true;
  public sasTnC: any;
  isCharter = false;
  flightResponseDetail: any;
  flightType: any;
  eRgex: RegExp;
  pnrForm: FormGroup;
  showSasTnC = false;
  showPnrErrorMsg = false;
  showVoucherErrorMsg = false;
  showFnameErrorMsg = false;
  showLnameErrorMsg = false;
  showEmailErrorMsg = false;
  showCharterVoucherErrorMsg = false;
  showSastandcErrorMsg = false;
  pnrPatternMessage: any;
  pnrFocused = false;
  voucherFocused= false;
  fNameFocused = false;
  lNameFocused = false;
  voucherFocued= false;
  emailFocused = false;
  pnrTopSet = false;
  voucherTopSet = false;
  fnameTopSet = false;
  lnameTopSet = false;
  emailTopSet = false;
  showTermsCondition: any;
  voucherCode:any='';
  voucherErrorMessage='';
  accessiTranslate = { 'enterToContinue': '' };
  public passengerDetailsToPrePopulate: any;
  public activateStatus: any;
  @ViewChild('pnrInfoIcon', { static: false }) private pnrInfoIcon: ElementRef;

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement) {
    if (this.pnrInfoIcon && !this.pnrInfoIcon.nativeElement.contains(targetElement)) {
      this.displayPNRInfo = false;
    }
  }

  @Output() formSubmit: EventEmitter<any> = new EventEmitter();
  @Output() openSasTnc: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private travelersService: TravelersService,
    private accessibilityService: AccessibilityService,
    private activatedRoute: ActivatedRoute,
    private travellersService: TravellersService,
    private translate: TranslateService,
    private httpService: HttpService,
    private buyWifiService: BuywifiService,
    private appService: AppService) {
  }

  ngOnInit() {
    this.appService.removeScrollBody();
    this.appService.removePositionValue();
    this.showTermsCondition = LandingComponent.showToggleButton;
    this.buyWifiService.setSessionValue(0);
    this.getTnCData();
    this.eRgex = /^[_a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[_a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,6})$/;
    this.isCharter = this.appService.getFlightServiceType();
    this.flightResponseDetail = this.appService.getFlightResponse();
    if (this.isCharter) {
      if (!this.showTermsCondition) {
        this.pnrForm = this.fb.group({

          'firstname': ['', [Validators.required,
          Validators.pattern('^[\\sa-zA-Z\\u0080-\\u00ff\.\'\-]*$'),
          Validators.minLength(2),
          Validators.maxLength(32)]],
          'secondname': ['', [Validators.required,
          Validators.pattern('^[\\sa-zA-Z\\u0080-\\u00ff\.\'\-]*$'),
          Validators.minLength(2),
          Validators.maxLength(32)]],
          'email': ['', [Validators.required,
          Validators.pattern(this.eRgex)]]
        });
      } else {
        this.pnrForm = this.fb.group({
          'firstname': ['', [Validators.required,
          Validators.pattern('^[\\sa-zA-Z\\u0080-\\u00ff\.\'\-]*$'),
          Validators.minLength(2),
          Validators.maxLength(32)]],
          'secondname': ['', [Validators.required,
          Validators.pattern('^[\\sa-zA-Z\\u0080-\\u00ff\.\'\-]*$'),
          Validators.minLength(2),
          Validators.maxLength(32)]],
          'email': ['', [Validators.required,
          Validators.pattern(this.eRgex)]],
          'voucher': ['', [
            Validators.required
           ]],
          'sastandc': ['', [Validators.requiredTrue]]
        });
      }
    } else {
      if (!this.showTermsCondition) {
        this.pnrForm = this.fb.group({
          'pnr': ['', [Validators.required,
          Validators.pattern('^[\\a-zA-Z0-9]*$'),
          this.pnrHasZeroValidator,
          Validators.minLength(5),
          Validators.maxLength(6)]],
          'firstname': ['', [Validators.required,
          Validators.pattern('^[\\sa-zA-Z\\u0080-\\u00ff\.\'\-]*$'),
          Validators.minLength(2),
          Validators.maxLength(32)]],
          'secondname': ['', [Validators.required,
          Validators.pattern('^[\\sa-zA-Z\\u0080-\\u00ff\.\'\-]*$'),
          Validators.minLength(2),
          Validators.maxLength(32)]]
        });
      } else {
        this.pnrForm = this.fb.group({
          'pnr': ['', [Validators.required,
          Validators.pattern('^[\\a-zA-Z0-9]*$'),
          this.pnrHasZeroValidator,
          Validators.minLength(5),
          Validators.maxLength(6)]],
          'firstname': ['', [Validators.required,
          Validators.pattern('^[\\sa-zA-Z\\u0080-\\u00ff\.\'\-]*$'),
          Validators.minLength(2),
          Validators.maxLength(32)]],
          'secondname': ['', [Validators.required,
          Validators.pattern('^[\\sa-zA-Z\\u0080-\\u00ff\.\'\-]*$'),
          Validators.minLength(2),
          Validators.maxLength(32)]],
          'sastandc': ['', [Validators.requiredTrue]]
        });
      }
    }
    this.pnrForm.valueChanges
      .map((value) => {
        if (this.isCharter) {
          value.firstname = value.firstname != null ? value.firstname.trim() : '';
          value.secondname = value.secondname != null ? value.secondname.trim() : '';
          value.email = value.email != null ? value.email.trim() : '';
        } else {
          value.pnr = value.pnr != null ? value.pnr.trim() : '';
          value.firstname = value.firstname != null ? value.firstname.trim() : '';
          value.secondname = value.secondname != null ? value.secondname.trim() : '';
        }

        return null;
      })
      .subscribe((value) => { });
    this.pnrDataUpdate();
    this.loadAccessibilityTranslations();
    this.travellersFormDetailsToPrePopulate();
    this.accessibilityService.focus('#bookRefAc');
  }



  pnrFormSubmit() {
    if (this.pnrForm.valid && !this.showVoucherErrorMsg) {
      if (this.isCharter) {
        //For now we are using the same method for charter too
        this.travelersService.setPnrVoucherFormData(this.pnrForm.value,this.voucherCode);
      } else {
        this.travelersService.setPnrVoucherFormData(this.pnrForm.value,this.voucherCode);
      }

      this.formSubmit.emit();
    } else {
      if (!this.showTermsCondition) {
        this.formSubmitWithOutTC();
      } else {
        this.formSubmitWithTC();
      }
    }
  }
  formSubmitWithOutTC() {
    if (this.pnrForm.get('firstname').errors) {
      this.showFnameErrorMsg = true;
    } else if (this.pnrForm.get('secondname').errors) {
      this.showLnameErrorMsg = true;
    } else if (this.isCharter) {
      if (this.pnrForm.get('email').errors) {
        this.showEmailErrorMsg = true;
      }
    } else if (!this.isCharter) {
      if (this.pnrForm.get('pnr').errors) {
        this.showPnrErrorMsg = true;
      }
    }
  }

  formSubmitWithTC() {
    if (this.pnrForm.get('firstname').errors) {
      this.showFnameErrorMsg = true;
    } else if (this.pnrForm.get('secondname').errors) {
      this.showLnameErrorMsg = true;
    } else if (this.isCharter && this.pnrForm.get('email').errors) {
      this.showEmailErrorMsg = true;
    } 
    else if (this.isCharter && this.pnrForm.get('voucher').errors) {
      this.showCharterVoucherErrorMsg = true;
    } 
    else if (!this.isCharter && this.pnrForm.get('pnr').errors) {
      this.showPnrErrorMsg = true;
    } 
    else if (this.pnrForm.get('sastandc').errors) {
      this.showSastandcErrorMsg = true;
    }
  }

  pnrDataUpdate() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params && (params.pnr || params.firstname || params.lastname)) {
        const travelersObj = this.validateParamsData(params);
        if (travelersObj.pnr === '') {
          this.accessibilityService.focus('#bookRef');
        } else if (travelersObj.firstname === '') {
          this.accessibilityService.focus('#firstName');
        } else if (travelersObj.secondname === '') {
          this.accessibilityService.focus('#lastName');
        } else if (travelersObj.email === '') {
          this.accessibilityService.focus('#email');
        } else {
          this.pnrFormSubmit();
        }
      } else {
        this.accessibilityService.focus('#activate-header');
      }
    });
  }

  validateParamsData(params) {
    let travelersObj = { pnr: '', firstname: '', secondname: '', email: '' };
    travelersObj = this.updateParamsValue(travelersObj, params);
    if (this.pnrForm.controls['pnr']) {
      this.pnrForm.controls['pnr'].setValue(travelersObj.pnr);
    }
    this.pnrForm.controls['firstname'].setValue(travelersObj.firstname);
    this.pnrForm.controls['secondname'].setValue(travelersObj.secondname);
    if (this.pnrForm.controls['email']) {
      this.pnrForm.controls['email'].setValue(travelersObj.email);
    }
    if (this.pnrForm.controls['sastandc']) {
      this.pnrForm.controls['sastandc'].setValue(true);
    }
    this.pnrTopSet = true;
    this.voucherTopSet= true;
    this.fnameTopSet = true;
    this.lnameTopSet = true;
    return travelersObj;
  }

  updateParamsValue(travelersObj, params) {
    if (params.pnr && params.pnr !== '') {
      travelersObj.pnr = params.pnr;
    }
    if (params.firstname && params.firstname !== '') {
      travelersObj.firstname = params.firstname;
    }
    if (params.lastname && params.lastname !== '') {
      travelersObj.secondname = params.lastname;
    }
    if (params.email && params.email !== '') {
      travelersObj.email = params.email;
    }
    return travelersObj;
  }

  get pnr() {
    return this.pnrForm.get('pnr');
  }

  get firstname() {
    return this.pnrForm.get('firstname');
  }

  get secondname() {
    return this.pnrForm.get('secondname');
  }
  get email() {
    return this.pnrForm.get('email');
  }

  get voucher(){
    return this.pnrForm.get('voucher');
  }

  get sastandc() {
    return this.pnrForm.get('sastandc');
  }

  onActivePnr() {
    this.showPnrErrorMsg = false;
    this.pnrFocused = true;
    this.displayPNRInfoIcon = false;
    this.checkPnrValue();
    this.pnrTopSet = true;
  }

  onFocusVoucher() {
    this.showVoucherErrorMsg = false;
    this.showCharterVoucherErrorMsg = false;
    this.voucherFocued = true;
    this.displayPNRInfoIcon = false;
    this.checkVoucherValue();
    this.voucherTopSet = true;
  }

  onBlurVoucher() {

   //console.log('Blur');
    this.voucherFocued = false;
    this.displayPNRInfoIcon = true;
    this.displayPNRInfo = false;
    this.checkVoucherValue();
    this.voucherErrorCheck();
  }
  onBlurPnr() {
    if (this.pnrForm.get('pnr').value !== '') {
      this.updateTrimValueBasedOnFlow();
      this.showPnrErrorMsg = true;
    } else {
      this.showPnrErrorMsg = false;
    }
    this.accessibilityService.updateAttributeValue('#bookRef', 'aria-invalid', 'true');
    this.pnrFocused = false;
    this.displayPNRInfoIcon = true;
    this.displayPNRInfo = false;
    this.checkPnrValue();
  }

  onActivePnrInfoIcon() {
    this.displayPNRInfo = true;
  }
  onBlurPnrInfoIcon() {
    this.displayPNRInfo = false;
  }
  checkPnrValue() {
    let pnrEmpty: any;
    const pnrErrors = this.pnrForm.get('pnr').errors;
    if (pnrErrors) {
      pnrEmpty = pnrErrors.required;
    }
    if (!pnrEmpty || this.pnrFocused) {
      this.pnrTopSet = true;
    } else {
      this.pnrTopSet = false;
    }
    if (!pnrErrors) {
      this.accessibilityService.updateAttributeValue('#bookRef', 'aria-invalid', 'false');
    }
  }

  checkVoucherValue() {
    let voucherError: any;
    this.showVoucherErrorMsg =false;
    this.showCharterVoucherErrorMsg = false;
    this.voucherCode = (<HTMLInputElement>document.getElementById('voucherCode')).value;
    if(this.voucherFocued) {
      this.voucherTopSet = true;
    } else {
      if(this.voucherCode == "") {
        this.voucherTopSet = false;
      }
      else {
        this.voucherTopSet = true;
      }
    }
    
  }

  voucherErrorCheck() {
    if(this.voucherCode.trim() == "") {
      this.showCharterVoucherErrorMsg = false;
      this.showVoucherErrorMsg= true;
      this.voucherErrorMessage = "Please enter voucher code"
    } else if(this.voucherCode.trim().length != 8 ) {
      this.showCharterVoucherErrorMsg = false;
      this.showVoucherErrorMsg = true;
      this.voucherErrorMessage = "Please verify your voucher code";
    } else if(this.voucherCode.indexOf('0') != -1) {
      this.showCharterVoucherErrorMsg = false;
      this.showVoucherErrorMsg = true;
      this.voucherErrorMessage = "You have incorrectly entered zero instead of the alphabet character 'O'."
    }
  }
  onActiveFname() {
    this.showFnameErrorMsg = false;
    this.fNameFocused = true;
    this.displayPNRInfo = false;
    this.checkFnameValue();
    this.fnameTopSet = true;
  }

  onBlurFname() {
    if (this.pnrForm.get('firstname').value !== '') {
      this.updateTrimValueBasedOnFlow();
      this.showFnameErrorMsg = true;
    } else {
      this.showFnameErrorMsg = false;
    }
    this.accessibilityService.updateAttributeValue('#firstName', 'aria-invalid', 'true');
    this.fNameFocused = false;
    this.checkFnameValue();
  }

  checkFnameValue() {
    let fnameEmpty: any;
    const fnameErrors = this.pnrForm.get('firstname').errors;
    if (fnameErrors) {
      fnameEmpty = fnameErrors.required;
    }
    if (!fnameEmpty || this.fNameFocused) {
      this.fnameTopSet = true;
    } else {
      this.fnameTopSet = false;
    }
    if (!fnameErrors) {
      this.accessibilityService.updateAttributeValue('#firstName', 'aria-invalid', 'false');
    }
  }

  onActiveLname() {
    this.showLnameErrorMsg = false;
    this.lNameFocused = true;
    this.checkLnameValue();
    this.lnameTopSet = true;
  }

  updateTrimValueBasedOnFlow() {
    if (this.showTermsCondition) {
      this.updateTrimValue();
    } else {
      this.updateTrimValueForBuy();
    }
  }

  onBlurLname() {
    if (this.pnrForm.get('secondname').value !== '') {
      this.updateTrimValueBasedOnFlow();
      this.showLnameErrorMsg = true;
    } else {
      this.showLnameErrorMsg = false;
    }
    this.accessibilityService.updateAttributeValue('#lastName', 'aria-invalid', 'true');
    this.lNameFocused = false;
    this.checkLnameValue();
  }

  checkLnameValue() {
    let LnameEmpty: any;
    const lnameErrors = this.pnrForm.get('secondname').errors;
    if (lnameErrors) {
      LnameEmpty = lnameErrors.required;
    }
    if (!LnameEmpty || this.lNameFocused) {
      this.lnameTopSet = true;
    } else {
      this.lnameTopSet = false;
    }
    if (!lnameErrors) {
      this.accessibilityService.updateAttributeValue('#lastName', 'aria-invalid', 'false');
    }
  }

  getTnCData() {
    const tncUrls = this.travelersService.getTnCUrls();
    if (tncUrls) {
      this.httpService.getHtml(tncUrls.sas).subscribe(tncData => {
        this.sasTnC = tncData;
      })
    }
  }

  onActiveEmail() {
    this.showEmailErrorMsg = false;
    this.emailFocused = true;
    this.displayPNRInfo = false;
    this.checkEmailValue();
    this.emailTopSet = true;
  }

  onBlurEmail() {
    if (this.pnrForm.get('email').value !== '') {
      this.updateTrimValue();
      this.showEmailErrorMsg = true;
    } else {
      this.showEmailErrorMsg = false;
    }
    this.accessibilityService.updateAttributeValue('#email', 'aria-invalid', 'true');
    this.emailFocused = false;
    this.checkEmailValue();
  }

  checkEmailValue() {
    let emailEmpty: any;
    const emailErrors = this.pnrForm.get('email').errors;
    if (emailErrors) {
      emailEmpty = emailErrors.required;
    }
    if (!emailEmpty || this.emailFocused) {
      this.emailTopSet = true;
    } else {
      this.emailTopSet = false;
    }
    if (!emailErrors) {
      this.accessibilityService.updateAttributeValue('#email', 'aria-invalid', 'false');
    }
  }

  checkSasTnC() {
    this.showSastandcErrorMsg = false;
  }

  openSasTnC() {
    this.openSasTnc.emit();
    this.showSasTnC = true;
    this.accessibilityService.focus('#sasTnCAcc');
    this.appService.setScrollTop('#myModal');
    return false;
  }

  closeSasTnCEvent() {
    this.showSasTnC = false;
  }

  // Accessiblity methods
  tabFromViasatLink(event) {
    event.preventDefault();
    this.accessibilityService.focus('#connect-btn');
  }

  tabFromActivateButton(event) {
    event.preventDefault();
    this.accessibilityService.focus('#activate-close');
  }

  // Accessibility Methods
  private loadAccessibilityTranslations() {
    this.translate.get(['wifiLogin.connect', 'button', 'pressEnter', 'loginAndAccess']).subscribe(result => {
      const connectBtn = `${result['wifiLogin.connect']} ${result['button']}.`;
      this.accessiTranslate.enterToContinue = connectBtn + result['pressEnter'] + result['loginAndAccess'];
    });
  }

  updateTrimValue() {
    if (this.isCharter) {
      if (!this.showTermsCondition) {
        this.pnrForm.setValue({
          'email': this.pnrForm.get('email').value.trim(),
          'firstname': this.pnrForm.get('firstname').value.trim(),
          'secondname': this.pnrForm.get('secondname').value.trim(),
          'voucher': this.pnrForm.get('voucher').value.trim(),
        });
      } else {
        this.pnrForm.setValue({
          'email': this.pnrForm.get('email').value.trim(),
          'firstname': this.pnrForm.get('firstname').value.trim(),
          'secondname': this.pnrForm.get('secondname').value.trim(),
          'voucher': this.pnrForm.get('voucher').value.trim(),
          'sastandc': this.pnrForm.get('sastandc').value
        });
      }
    } else {
      if (!this.showTermsCondition) {
        this.pnrForm.setValue({
          'pnr': this.pnrForm.get('pnr').value.trim(),
          'firstname': this.pnrForm.get('firstname').value.trim(),
          'secondname': this.pnrForm.get('secondname').value.trim()
        });
      } else {
        this.pnrForm.setValue({
          'pnr': this.pnrForm.get('pnr').value.trim(),
          'firstname': this.pnrForm.get('firstname').value.trim(),
          'secondname': this.pnrForm.get('secondname').value.trim(),
          'sastandc': this.pnrForm.get('sastandc').value
        });
      }
    }
  }

  updateTrimValueForBuy() {
    if (this.isCharter) {
      this.pnrForm.setValue({
        'email': this.pnrForm.get('email').value.trim(),
        'firstname': this.pnrForm.get('firstname').value.trim(),
        'secondname': this.pnrForm.get('secondname').value.trim()
      });
    } else {
      this.pnrForm.setValue({
        'pnr': this.pnrForm.get('pnr').value.trim(),
        'firstname': this.pnrForm.get('firstname').value.trim(),
        'secondname': this.pnrForm.get('secondname').value.trim()
      });
    }
  }

  travellersFormDetailsToPrePopulate() {
    this.passengerDetailsToPrePopulate = this.travellersService.getPassengerDetails();
    if (this.passengerDetailsToPrePopulate) {
      this.pnrForm.controls['pnr'].setValue(this.passengerDetailsToPrePopulate.pnr);
      this.pnrForm.controls['firstname'].setValue(this.passengerDetailsToPrePopulate.firstname);
      this.pnrForm.controls['secondname'].setValue(this.passengerDetailsToPrePopulate.secondname);
      this.pnrTopSet = true;
      this.voucherTopSet=true;
      this.fnameTopSet = true;
      this.lnameTopSet = true;
    }
  }

  pnrHasZeroValidator(formControl: FormControl) {
    if (formControl.value) {
      const matches = formControl.value.match(/^[\\a-zA-Z1-9]*$/);
      return matches ? null : { 'pnrHasZero': true };
    } else {
      return null;
    }
  }
  voucherHasZeroValidator(formControl: FormControl) {
    if (formControl.value) {
      const matches = formControl.value.match(/^[\\a-zA-Z1-9]*$/);
      return matches ? null : { 'voucherHasZero': true };
    } else {
      return null;
    }
  }
}
